module.exports = __webpack_public_path__ + "static/LOGO 5-2d8f03af70001f2e1ba9c77aede8fd15.png";